import Vue from "vue";
import ApiService from "../../../../../services/api";
import moment from "moment";
import { mapGetters } from "vuex";
import helpers from "../../../../../shared/fleetbox-helpers";

export default {
	props: {
		filters: Array,
		reportName: String
	},
	data: function() {
		return {
			journeyTitle: "",
			//#region 1 chart - KM Trips
			journeyChartKmTrips: [
				{
					name: "Periodo precedente",
					field: "previous",
					color: "#3c89b5",
					labels: {
						visible: true,
						template: this.getStackValue,
						background: "none",
						font: "10px montserrat-light"
					}
				},
				{
					name: "Periodo attuale",
					field: "current",
					color: "#1f6893",
					labels: {
						visible: true,
						template: this.getStackValue,
						background: "none",
						font: "10px montserrat-light"
					}
				}
			],
			journeyChartKmTripsExport: [
				{
					name: "Periodo precedente",
					field: "previous",
					color: "#3c89b5",
					labels: {
						visible: true,
						template: this.getStackValue,
						background: "none",
						font: "13px montserrat-light"
					}
				},
				{
					name: "Periodo attuale",
					field: "current",
					color: "#1f6893",
					labels: {
						visible: true,
						template: this.getStackValue,
						background: "none",
						font: "13px montserrat-light"
					}
				}
			],
			journeyChartKmTripsData: [],
			journeyChartKmTripsCategoryAxis: {
				categories: [],
				majorGridLines: {
					visible: false
				},
				labels: {
					font: "10px montserrat-light"
				}
			},
			//#endregion 1 chart - KM Trips
			//#region 2 chart - Total LT
			journeyChartTotalLt: [
				{
					name: "Periodo precedente",
					field: "previous",
					color: "#c05369",
					labels: {
						visible: true,
						template: this.getStackValue,
						background: "none",
						font: "10px montserrat-light"
					}
				},
				{
					name: "Periodo attuale",
					field: "current",
					color: "#731024",
					labels: {
						visible: true,
						template: this.getStackValue,
						background: "none",
						font: "10px montserrat-light"
					}
				}
			],
			journeyChartTotalLtExport: [
				{
					name: "Periodo precedente",
					field: "previous",
					color: "#c05369",
					labels: {
						visible: true,
						template: this.getStackValue,
						background: "none",
						font: "13px montserrat-light"
					}
				},
				{
					name: "Periodo attuale",
					field: "current",
					color: "#731024",
					labels: {
						visible: true,
						template: this.getStackValue,
						background: "none",
						font: "13px montserrat-light"
					}
				}
			],
			journeyChartTotalLtData: [],
			journeyChartTotalLtCategoryAxis: {
				categories: [],
				majorGridLines: {
					visible: false
				},
				labels: {
					font: "10px montserrat-light"
				}
			},
			//#endregion 2 chart - Total LT
			//#region 3 chart - Avg Consumption (DV)
			journeyChartAvgFuelConsumption: [
				{
					name: "Periodo precedente",
					field: "previous",
					color: "#1cc448",
					labels: {
						visible: true,
						template: this.getStackValue,
						background: "none",
						font: "10px montserrat-light"
					}
				},
				{
					name: "Periodo attuale",
					field: "current",
					color: "#018a25",
					labels: {
						visible: true,
						template: this.getStackValue,
						background: "none",
						font: "10px montserrat-light"
					}
				}
			],
			journeyChartAvgFuelConsumptionExport: [
				{
					name: "Periodo precedente",
					field: "previous",
					color: "#1cc448",
					labels: {
						visible: true,
						template: this.getStackValue,
						background: "none",
						font: "13px montserrat-light"
					}
				},
				{
					name: "Periodo attuale",
					field: "current",
					color: "#018a25",
					labels: {
						visible: true,
						template: this.getStackValue,
						background: "none",
						font: "13px montserrat-light"
					}
				}
			],
			journeyChartAvgFuelConsumptionData: [],
			journeyChartAvgFuelConsumptionCategoryAxis: {
				categories: [],
				majorGridLines: {
					visible: false
				},
				labels: {
					font: "10px montserrat-light"
				}
			},
			//#endregion 3 chart - Avg Consumption (DV)
			//#region 4 chart - Avg Consumption Brand
			journeyChartAvgFuelConsumptionBrand: [
				{
					name: "Periodo precedente",
					field: "previous",
					color: "#1cc448",
					labels: {
						visible: true,
						template: this.getStackValue,
						background: "none",
						font: "10px montserrat-light"
					}
				},
				{
					name: "Periodo attuale",
					field: "current",
					color: "#018a25",
					labels: {
						visible: true,
						template: this.getStackValue,
						background: "none",
						font: "10px montserrat-light"
					}
				}
			],
			journeyChartAvgFuelConsumptionBrandExport: [
				{
					name: "Periodo precedente",
					field: "previous",
					color: "#1cc448",
					labels: {
						visible: true,
						template: this.getStackValue,
						background: "none",
						font: "13px montserrat-light"
					}
				},
				{
					name: "Periodo attuale",
					field: "current",
					color: "#018a25",
					labels: {
						visible: true,
						template: this.getStackValue,
						background: "none",
						font: "13px montserrat-light"
					}
				}
			],
			journeyChartAvgFuelConsumptionBrandData: [],
			journeyChartAvgFuelConsumptionBrandCategoryAxis: {
				categories: [],
				majorGridLines: {
					visible: false
				},
				labels: {
					font: "10px montserrat-light"
				}
			},
			//#endregion 4 chart - Avg Consumption Brand
			//#region 5 chart - co2 Emitted
			journeyChartCoEmitted: [
				{
					name: "Periodo precedente",
					field: "previous",
					color: "#999999",
					labels: {
						visible: true,
						template: this.getStackValue,
						background: "none",
						font: "10px montserrat-light"
					}
				},
				{
					name: "Periodo attuale",
					field: "current",
					color: "#666666",
					labels: {
						visible: true,
						template: this.getStackValue,
						background: "none",
						font: "10px montserrat-light"
					}
				}
			],
			journeyChartCoEmittedExport: [
				{
					name: "Periodo precedente",
					field: "previous",
					color: "#999999",
					labels: {
						visible: true,
						template: this.getStackValue,
						background: "none",
						font: "13px montserrat-light"
					}
				},
				{
					name: "Periodo attuale",
					field: "current",
					color: "#666666",
					labels: {
						visible: true,
						template: this.getStackValue,
						background: "none",
						font: "13px montserrat-light"
					}
				}
			],
			journeyChartCoEmittedData: [],
			journeyChartCoEmittedCategoryAxis: {
				categories: [],
				majorGridLines: {
					visible: false
				},
				labels: {
					maring: 0,
					visible: false,
					font: "10px montserrat-light"
				},
				title: {
					text: "emissioni CO 2",
					visual: function(e) {
						var labelColor = e.options.color;
						var layout = new kendo.drawing.Layout(e.rect, {
							orientation: "horizontal",
							alignItems: "end",
							alignContent: "end",
							justifyContent: "center"
						});

						var labelCenter = new kendo.drawing.Text(" CO", [0, 0], {
							fill: {
								color: labelColor
							},
							font: "10px 'Montserrat Light', montserrat-light"
						});

						var labelSuf = new kendo.drawing.Text("2", [0, 0], {
							fill: {
								color: labelColor
							},
							font: "8px 'Montserrat Light', montserrat-light !important "
						});

						var labelPre = new kendo.drawing.Text(" EMISSIONI", [0, 0], {
							fill: {
								color: labelColor
							},
							font: "10px 'Montserrat Light', montserrat-light"
						});
						layout.append(labelPre, labelCenter, labelSuf);
						layout.reflow();
						return layout;
					}
				}
			},
			//#endregion 5 chart - co2 Emitted
			//#region 6 chart - Total Brand LT
			journeyChartTotalBrandLt: [
				{
					name: "Periodo precedente",
					field: "previous",
					color: "rgb(234, 240, 72)",
					labels: {
						visible: true,
						template: this.getStackValue,
						background: "none"
					}
				},
				{
					name: "Periodo attuale",
					field: "current",
					color: "rgb(240, 208, 72)",
					labels: {
						visible: true,
						template: this.getStackValue,
						background: "none"
					}
				}
			],
			journeyChartTotalBrandLtExport: [
				{
					name: "Periodo precedente",
					field: "previous",
					color: "rgb(234, 240, 72)",
					labels: {
						visible: true,
						template: this.getStackValue,
						background: "none",
						font: "13px montserrat-light"
					}
				},
				{
					name: "Periodo attuale",
					field: "current",
					color: "rgb(240, 208, 72)",
					labels: {
						visible: true,
						template: this.getStackValue,
						background: "none",
						font: "13px montserrat-light"
					}
				}
			],
			journeyChartTotalBrandLtData: [],
			journeyChartTotalBrandLtCategoryAxis: {
				categories: [],
				majorGridLines: {
					visible: false
				},
				labels: {
					font: "10px montserrat-light"
				}
			},
			//#endregion 6 chart - Total Brand LT

			//#region shared data chart
			journeyChartTooltip: {
				visible: true,
				template: this.getJourneyTooltip
			},
			journeyChartValueAxis: [
				{
					//max: 50,
					line: {
						visible: false
					},
					minorGridLines: {
						visible: false
					},
					labels: {
						//content: this.getTimeFromString,
						visible: false
					}
				}
			],

			journeyChartChartIndex: 0,
			//#endregion shared data chart

			//#region MODAL
			journeyModalShow: false,
			journeyChartTitle: "",
			journeyChartModalIndex: 0,

			journeyChartPdfOptions: {
				landscape: true,
				fileName: "percorrenza",
				title: "PERCORRENZA"
			},

			journeyChartLegend: {
				position: "bottom",
				item: {
					visual: function(e) {
						var rect = new kendo.geometry.Rect([0, 0], [800, 200]);
						var layout = new kendo.drawing.Layout(rect, {
							spacing: 5,
							alignItems: "center"
						});

						var color = e.series.color; //e.options.markers.background;
						var labelColor = e.options.labels.color;

						var marker = new kendo.drawing.Path({
							fill: {
								color: color
							},
							stroke: {
								color: color
							}
						})
							.moveTo(0, 0)
							.lineTo(0, 10)
							.lineTo(30, 10)
							.lineTo(30, 0)
							.close();

						var label = new kendo.drawing.Text(e.series.name.toUpperCase(), [0, 0], {
							fill: {
								color: labelColor
							},
							font: "12px 'Montserrat Light', montserrat-light !important"
						});

						var rectGeom = new kendo.geometry.Rect([0, 0], [30, 10]);
						var rectangle = new kendo.drawing.Rect(rectGeom, {
							fill: { color: "none" },
							stroke: { color: "none" }
						});

						layout.append(marker, label, rectangle);
						layout.reflow();

						return layout;
					}
				}
			},

			journeyChartKmTripsValueAxisModal: [
				{
					narrowRange: false,
					line: {
						visible: false
					},
					minorGridLines: {
						visible: false
					},
					title: {
						text: "KM",
						rotation: 0,
						font: "13px montserrat-light"
					},
					labels: {
						visible: true,
						font: "13px montserrat-light",
						format: "n0"
					}
				}
			],

			journeyChartLTValueAxisModal: [
				{
					narrowRange: false,
					line: {
						visible: false
					},
					minorGridLines: {
						visible: false
					},
					title: {
						text: "LT",
						rotation: 0,
						font: "13px montserrat-light"
					},
					labels: {
						visible: true,
						font: "13px montserrat-light",
						format: "n0"
					}
				}
			],

			journeyChartLtHKmValueAxisModal: [
				{
					narrowRange: false,
					line: {
						visible: false
					},
					minorGridLines: {
						visible: false
					},
					title: {
						text: "LT/100KM",
						rotation: 0,
						font: "13px montserrat-light"
					},
					labels: {
						visible: true,
						font: "13px montserrat-light",
						format: "n0"
					}
				}
			],

			journeyChartKmLtValueAxisModal: [
				{
					narrowRange: false,
					line: {
						visible: false
					},
					minorGridLines: {
						visible: false
					},
					title: {
						text: "KM/LT",
						rotation: 0,
						font: "13px montserrat-light"
					},
					labels: {
						visible: true,
						font: "13px montserrat-light",
						format: "n0"
					}
				}
			],

			journeyChartKgValueAxisModal: [
				{
					narrowRange: false,
					line: {
						visible: false
					},
					minorGridLines: {
						visible: false
					},
					title: {
						text: "KG",
						rotation: 0,
						font: "13px montserrat-light"
					},
					labels: {
						visible: true,
						font: "13px montserrat-light",
						format: "n0"
					}
				}
			],
			vehicleIdFilterField: "number_plate",
			vehicleIdFilterFieldFormatted: "vehicles"
			//#endregion
		};
	},
	created() {
		this.vehicleIdFilterField = this.settings.vehicleIdFilterField;
		this.vehicleIdFilterFieldFormatted = "vehicles";
		if (this.vehicleIdFilterField == "code") {
			this.vehicleIdFilterFieldFormatted = "vehicleCodes";
		}
	},
	mounted() {
		this.getData();
	},
	// watch: {
	// 	filters: {
	// 		handler: function() {
	// 			this.getData();
	// 		},
	// 		deep: true
	// 	}
	// },
	methods: {
		applyReportFilter() {
			this.getData();
		},
		getJourneyTitle(obj) {
			return this.journeyTitle.replace("{0}", obj);
		},
		journeyChartClickHandler() {
			var self = this;

			self.journeyModalShow = true;
			setTimeout(() => {
				self.journeyChartModalIndex++;
			}, 200);
		},
		getCurrentSeriesColor(e) {
			switch (e.category.toLowerCase()) {
				case "km viaggi":
					return "rgb(0, 51, 255)";
					break;

				case "consumo medio (dv)":
					return "rgb(82, 82, 191)";
					break;

				case "consumo costruttore":
					return "rgb(82, 82, 191)";
					break;

				case "co2":
					return "rgb(80, 145, 0)";
					break;
			}
		},
		getPreviousSeriesColor(e) {
			switch (e.category.toLowerCase()) {
				case "km viaggi":
					return "rgb(52, 164, 235)";
					break;

				case "consumo medio (dv)":
					return "rgb(146, 146, 247)";
					break;

				case "consumo costruttore":
					return "rgb(146, 146, 247)";
					break;

				case "co2":
					return "rgb(116, 212, 0)";
					break;
			}
		},
		getJourneyTooltip(e) {
			if (e.series.field == "current") {
				return `<span>${e.dataItem.name} - ${e.series.name} dal ${e.dataItem.from} al ${e.dataItem.to}: ${kendo.toString(e.dataItem.current, "n2")}</span>`;
			} else {
				return `<span>${e.dataItem.name} - ${e.series.name} dal ${e.dataItem.previousfrom} al ${e.dataItem.previousto}: ${kendo.toString(e.dataItem.previous, "n2")}</span>`;
			}
		},
		getStackValue(e) {
			return kendo.toString(e.stackValue, "n2");
		},
		getData: function() {
			var self = this;

			this.$emit("on-loading", true);

			var data = this.getRequestData();

			data["page"] = 0;
			data["pageSize"] = 0;

			ApiService.getJourneySyntheticChart(data).then(res => {
				var currentData = res;

				var timesFilter = self.filters.find(item => {
					return item.id == "timerange";
				});

				var startDate = moment(timesFilter.value.startRange);
				var endDate = moment(timesFilter.value.endRange);
				var diffDay = endDate.diff(startDate, "days") + 1;

				var newStartDate = moment(startDate).add(-diffDay, "days");
				var newEndDate = moment(newStartDate)
					.add(diffDay, "days")
					.add(-1, "minutes");

				data["dateRange.From"] = moment(newStartDate)
					.utc()
					.format();
				data["dateRange.To"] = moment(newEndDate)
					.utc()
					.format();

				ApiService.getJourneySyntheticChart(data).then(res => {
					var currentFromDate = self.$options.filters.dateToString(startDate);
					var currentEndDate = self.$options.filters.dateToString(endDate);

					var previousFromDate = self.$options.filters.dateToString(newStartDate);
					var previousEndDate = self.$options.filters.dateToString(newEndDate);
					self.setJourneySyntheticData(currentData, currentFromDate, currentEndDate, res, previousFromDate, previousEndDate);

					self.$emit("on-loading", false);
				});
			});
		},
		getRequestData() {
			var self = this;
			var data = {};

			if (this.filters && this.filters.length > 0) {
				this.filters.forEach(element => {
					switch (element.id) {
						case "timerange":
							data["dateRange.From"] = moment(element.value.startRange)
								.utc()
								.format();
							data["dateRange.To"] = moment(element.value.endRange)
								.utc()
								.format();
							break;
						case "divisions":
							if (element.value) {
								data["division"] = element.value;
							}
							break;
						case "groups":
							if (element.value && element.value != -1) {
								data["group"] = element.value;
							}
							break;
						case "vehicles":
							if (element.value && element.value.length > 0) {
								for (var j = 0; j < element.value.length; j++) {
									var field = `${self.vehicleIdFilterFieldFormatted}[${j}]`;
									var value = element.value[j];

									data[field] = value;
								}
							}
							break;
						case "drivers":
							if (element.value) {
								data["driver"] = element.value;
							}
							break;

						default:
							break;
					}
				});
			}

			return data;
		},
		setJourneySyntheticData(currentData, currentFromDate, currentEndDate, previousData, previousFromDate, previousEndDate) {
			var self = this;

			self.journeyTitle = `{0} DAL ${previousFromDate} AL ${currentEndDate}`;
			let reportName = "Percorrenza";
			if (this.reportName) {
				reportName = this.reportName.replace(/[ ]/g, "_");
			}
			self.journeyChartPdfOptions.fileName = helpers.chartPdffileName(this, reportName, moment(previousFromDate, "DD/MM/YYYY"), moment(currentEndDate, "DD/MM/YYYY"));
			self.journeyChartCoEmittedData = [];
			self.journeyChartKmTripsData = [];
			self.journeyChartTotalLtData = [];
			self.journeyChartTotalBrandLtData = [];
			self.journeyChartAvgFuelConsumptionData = [];
			self.journeyChartAvgFuelConsumptionBrandData = [];

			self.journeyChartAvgFuelConsumptionBrandCategoryAxis.categories = [];
			self.journeyChartAvgFuelConsumptionCategoryAxis.categories = [];
			self.journeyChartTotalLtCategoryAxis.categories = [];
			self.journeyChartTotalBrandLtCategoryAxis.categories = [];
			self.journeyChartKmTripsCategoryAxis.categories = [];
			self.journeyChartCoEmittedCategoryAxis.categories = [];

			self.journeyChartKmTripsCategoryAxis.categories.push(`KM VIAGGI (KM)`);
			self.journeyChartTotalLtCategoryAxis.categories.push("LITRI TOTALI CONSUMATI (LT)");
			self.journeyChartTotalBrandLtCategoryAxis.categories.push("LITRI TOTALI CONSUMATI COSTRUTTORE (LT)");
			self.journeyChartAvgFuelConsumptionCategoryAxis.categories.push(`CONSUMO MEDIO (L/100KM)`);
			self.journeyChartAvgFuelConsumptionBrandCategoryAxis.categories.push(`CONSUMO MEDIO (KM/l)`);
			self.journeyChartCoEmittedCategoryAxis.categories.push(`EMISSIONI C02`);

			//#region calculate data
			var currentTotalLt = 0;
			var currentTotalBrandLt = 0;
			var currentInterpolatedKm = 0;
			var currentAvgFuelCons = 0;
			var currentTotalInterpolatedKm = 0;
			var currentCo2 = 0;

			//var countCurrentAvgConsumptionData = 0;
			//var countPreviousAvgConsumptionData = 0;

			var previousTotalLt = 0;
			var previousTotalBrandLt = 0;
			var previousInterpolatedKm = 0;
			var previousAvgFuelCons = 0;
			var previousTotalInterpolatedKm = 0;
			var previousCo2 = 0;

			// if (currentData && currentData.length > 0) {
			// 	currentData.forEach(item => {
			// 		currentTotalLt += item.total_lt;
			// 		currentTotalBrandLt += item.brand_total_lt;
			// 		currentInterpolatedKm += item.total_interpolated_km;
			// 		currentAvgFuelCons += item.avg_consumption_lt_hkm;
			// 		currentTotalInterpolatedKm += item.total_interpolated_km;
			// 		currentCo2 += item.total_co2;

			// 		if (item.avg_consumption_lt_hkm > 0) countCurrentAvgConsumptionData++;
			// 	});
			// }

			if (currentData) {
				currentTotalLt = currentData.totalLt;
				currentTotalBrandLt = currentData.totalBrandLt;
				currentInterpolatedKm = currentData.totalInterpolatedKm;
				currentAvgFuelCons = currentData.avgFuelCons;
				currentTotalInterpolatedKm = currentData.totalInterpolatedKm;
				currentCo2 = currentData.totalCo2;
			}

			// if (previousData && previousData.length > 0) {
			// 	previousData.forEach(item => {
			// 		previousTotalLt += item.total_lt;
			// 		previousTotalBrandLt += item.brand_total_lt;
			// 		previousInterpolatedKm += item.total_interpolated_km;
			// 		previousAvgFuelCons += item.avg_consumption_lt_hkm;
			// 		previousTotalInterpolatedKm += item.total_interpolated_km;
			// 		previousCo2 += item.total_co2;

			// 		if (item.avg_consumption_lt_hkm > 0) countPreviousAvgConsumptionData++;
			// 	});
			// }

			if (previousData) {
				previousTotalLt = previousData.totalLt;
				previousTotalBrandLt = previousData.totalBrandLt;
				previousInterpolatedKm = previousData.totalInterpolatedKm;
				previousAvgFuelCons = previousData.avgFuelCons;
				previousTotalInterpolatedKm = previousData.totalInterpolatedKm;
				previousCo2 = previousData.totalCo2;
			}
			//#endregion

			self.journeyChartKmTripsData.push({
				from: currentFromDate,
				to: currentEndDate,
				previousfrom: previousFromDate,
				previousto: previousEndDate,
				name: "km viaggio",
				current: currentInterpolatedKm || 0,
				previous: previousInterpolatedKm || 0
			});

			self.journeyChartTotalLtData.push({
				from: currentFromDate,
				to: currentEndDate,
				previousfrom: previousFromDate,
				previousto: previousEndDate,
				name: "litri totali consumati",
				current: currentTotalLt || 0,
				previous: previousTotalLt || 0
			});

			self.journeyChartTotalBrandLtData.push({
				from: currentFromDate,
				to: currentEndDate,
				previousfrom: previousFromDate,
				previousto: previousEndDate,
				name: "litri totali consumati costruttore",
				current: currentTotalBrandLt || 0,
				previous: previousTotalBrandLt || 0
			});
			
			var currentAvgFuelConsumption = 0;
			if (currentTotalLt > 0 && currentInterpolatedKm > 0) currentAvgFuelConsumption = (currentTotalLt / currentInterpolatedKm) * 100;

			var previousAvgFuelConsumption = 0;
			if (previousTotalLt > 0 && previousInterpolatedKm > 0) previousAvgFuelConsumption = (previousTotalLt / previousInterpolatedKm) * 100;

			// var currentAvgFuelConsumption = currentAvgFuelCons / countCurrentAvgConsumptionData;
			// var previousAvgFuelConsumption = previousAvgFuelCons / countPreviousAvgConsumptionData;

			self.journeyChartAvgFuelConsumptionData.push({
				from: currentFromDate,
				to: currentEndDate,
				previousfrom: previousFromDate,
				previousto: previousEndDate,
				name: "consumo medio (l/100km)",
				current: currentAvgFuelConsumption || 0,
				previous: previousAvgFuelConsumption || 0
			});

			var currentTotalLtKm = 0;
			var previousTotalLtKm = 0;

			if (currentTotalInterpolatedKm > 0 && currentTotalLt > 0) currentTotalLtKm = currentTotalInterpolatedKm / currentTotalLt;
			if (previousTotalInterpolatedKm > 0 && previousTotalLt > 0) previousTotalLtKm = previousTotalInterpolatedKm / previousTotalLt;


			self.journeyChartAvgFuelConsumptionBrandData.push({
				from: currentFromDate,
				to: currentEndDate,
				previousfrom: previousFromDate,
				previousto: previousEndDate,
				name: "consumo medio (km/l)",
				current: currentTotalLtKm || 0,
				previous: previousTotalLtKm || 0
			});

			self.journeyChartCoEmittedData.push({
				from: currentFromDate,
				to: currentEndDate,
				previousfrom: previousFromDate,
				previousto: previousEndDate,
				name: "emissioni CO<sub>2</sub> (KG)",
				current: currentCo2 || 0,
				previous: previousCo2 || 0
			});

			self.journeyChartChartIndex++;
		},

		//#region export chart
		exportAsPdf() {
			var container = $(`<div>
				<div id="chart-container" style="width: 1100px;">
					<div id="chart" ></div>
					<div class="page-break" id="chart1"></div>
					<!-- <div class="page-break" id="chart2"></div> -->
					<div class="page-break" id="chart3"></div>
					<div class="page-break" id="chart4"></div>
					<div class="page-break" style="text-align: center">
					<span style="height: 50px; width: 500px; font: bold 20px montserrat-bold; margin-bottom: 10px; color: #777;" id="chart5-title"><sub>2</sub></span>
					<div id="chart5"></div>
					</div>
				</div>
			</div>`)
				.css({
					position: "absolute",
					top: 0,
					left: -1500,
					height: 700,
					"z-index": 99999
				})
				.appendTo("body");

			function cleanup() {
				//container.getKendoChart().destroy();
				container.remove();
			}

			this.createChart(container, "chart");
			this.createChart1(container, "chart1");
			//this.createChart2(container, "chart2");
			this.createChart3(container, "chart3");
			this.createChart4(container, "chart4");
			this.createChart5(container, "chart5");

			var fileName = this.journeyChartPdfOptions.fileName;

			setTimeout(() => {
				kendo.drawing
					.drawDOM($(container).find(`#chart-container`), {
						paperSize: "A3",
						landscape: true,
						margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
						forcePageBreak: ".page-break"
					})
					.then(function(group) {
						return kendo.drawing.exportPDF(group);
					})
					.done(function(data) {
						kendo.saveAs({
							dataURI: data,
							fileName: fileName
						});
						setTimeout(() => {
							cleanup();
						}, 500);
					});
			}, 800);
		},

		createChart(container, chartConatinerName) {
			var self = this;

			var options = {
				chartArea: {
					height: 700
				},
				pdf: self.journeyChartPdfOptions,
				theme: "metro",
				title: {
					text: self.getJourneyTitle("KM VIAGGI"),
					font: "bold 20px montserrat-bold"
				},
				legend: {
					position: "bottom",
					item: {
						visual: function(e) {
							var rect = new kendo.geometry.Rect([0, 0], [800, 200]);
							var layout = new kendo.drawing.Layout(rect, {
								spacing: 5,
								alignItems: "center"
							});

							var color = e.series.color; //e.options.markers.background;
							var labelColor = e.options.labels.color;

							var marker = new kendo.drawing.Path({
								fill: {
									color: color
								},
								stroke: {
									color: color
								}
							})
								.moveTo(0, 0)
								.lineTo(0, 10)
								.lineTo(30, 10)
								.lineTo(30, 0)
								.close();

							var label = new kendo.drawing.Text(e.series.name.toUpperCase(), [0, 0], {
								fill: {
									color: labelColor
								},
								font: "12px 'Montserrat Light', montserrat-light"
							});

							var rectGeom = new kendo.geometry.Rect([0, 0], [30, 10]);
							var rectangle = new kendo.drawing.Rect(rectGeom, {
								fill: { color: "none" },
								stroke: { color: "none" }
							});

							layout.append(marker, label);
							layout.reflow();

							return layout;
						}
					}
				},
				seriesDefault: {
					type: "column",
					labels: {
						visible: true
					}
				},
				dataSource: {
					data: self.journeyChartKmTripsData
				},
				series: self.journeyChartKmTripsExport,
				valueAxis: self.journeyChartKmTripsValueAxisModal,
				categoryAxis: {
					categories: self.journeyChartKmTripsCategoryAxis.categories,
					majorGridLines: {
						visible: false
					},
					line: {
						visible: false
					},
					labels: {
						font: "13px montserrat-light"
					}
				}
			};

			//options = $.extend(true, options, exportOptions);
			$(container)
				.find(`#${chartConatinerName}`)
				.kendoChart(options);
		},

		createChart1(container, chartConatinerName) {
			var self = this;

			var options = {
				chartArea: {
					height: 700
				},
				pdf: self.journeyChartPdfOptions,
				theme: "metro",
				title: {
					text: self.getJourneyTitle("LITRI TOTALI CONSUMATI"),
					font: "bold 20px montserrat-bold"
				},
				legend: {
					position: "bottom",
					item: {
						visual: function(e) {
							var rect = new kendo.geometry.Rect([0, 0], [800, 200]);
							var layout = new kendo.drawing.Layout(rect, {
								spacing: 5,
								alignItems: "center"
							});

							var color = e.series.color; //e.options.markers.background;
							var labelColor = e.options.labels.color;

							var marker = new kendo.drawing.Path({
								fill: {
									color: color
								},
								stroke: {
									color: color
								}
							})
								.moveTo(0, 0)
								.lineTo(0, 10)
								.lineTo(30, 10)
								.lineTo(30, 0)
								.close();

							var label = new kendo.drawing.Text(e.series.name.toUpperCase(), [0, 0], {
								fill: {
									color: labelColor
								},
								font: "12px 'Montserrat Light', montserrat-light"
							});

							var rectGeom = new kendo.geometry.Rect([0, 0], [30, 10]);
							var rectangle = new kendo.drawing.Rect(rectGeom, {
								fill: { color: "none" },
								stroke: { color: "none" }
							});

							layout.append(marker, label);
							layout.reflow();

							return layout;
						}
					}
				},
				seriesDefault: {
					type: "column",
					labels: {
						visible: true
					}
				},
				dataSource: {
					data: self.journeyChartTotalLtData
				},
				series: self.journeyChartTotalLtExport,
				valueAxis: self.journeyChartLTValueAxisModal,
				categoryAxis: {
					categories: self.journeyChartTotalLtCategoryAxis.categories,
					majorGridLines: {
						visible: false
					},
					line: {
						visible: false
					},
					labels: {
						font: "13px montserrat-light"
					}
				}
			};

			//options = $.extend(true, options, exportOptions);
			$(container)
				.find(`#${chartConatinerName}`)
				.kendoChart(options);
		},

		createChart2(container, chartConatinerName) {
			var self = this;

			var options = {
				chartArea: {
					height: 700
				},
				pdf: self.journeyChartPdfOptions,
				theme: "metro",
				title: {
					text: self.getJourneyTitle("LITRI TOTALI CONSUMATI COSTRUTTORE"),
					font: "bold 20px montserrat-bold"
				},
				legend: {
					position: "bottom",
					item: {
						visual: function(e) {
							var rect = new kendo.geometry.Rect([0, 0], [800, 200]);
							var layout = new kendo.drawing.Layout(rect, {
								spacing: 5,
								alignItems: "center"
							});

							var color = e.series.color; //e.options.markers.background;
							var labelColor = e.options.labels.color;

							var marker = new kendo.drawing.Path({
								fill: {
									color: color
								},
								stroke: {
									color: color
								}
							})
								.moveTo(0, 0)
								.lineTo(0, 10)
								.lineTo(30, 10)
								.lineTo(30, 0)
								.close();

							var label = new kendo.drawing.Text(e.series.name.toUpperCase(), [0, 0], {
								fill: {
									color: labelColor
								},
								font: "12px 'Montserrat Light', montserrat-light"
							});

							var rectGeom = new kendo.geometry.Rect([0, 0], [30, 10]);
							var rectangle = new kendo.drawing.Rect(rectGeom, {
								fill: { color: "none" },
								stroke: { color: "none" }
							});

							layout.append(marker, label);
							layout.reflow();

							return layout;
						}
					}
				},
				seriesDefault: {
					type: "column",
					labels: {
						visible: true
					}
				},
				dataSource: {
					data: self.journeyChartTotalBrandLtData
				},
				series: self.journeyChartTotalLtExport,
				valueAxis: self.journeyChartLTValueAxisModal,
				categoryAxis: {
					categories: self.journeyChartTotalBrandLtCategoryAxis.categories,
					majorGridLines: {
						visible: false
					},
					line: {
						visible: false
					},
					labels: {
						font: "13px montserrat-light"
					}
				}
			};

			//options = $.extend(true, options, exportOptions);
			$(container)
				.find(`#${chartConatinerName}`)
				.kendoChart(options);
		},

		createChart3(container, chartConatinerName) {
			var self = this;

			var options = {
				chartArea: {
					height: 700
				},
				pdf: self.journeyChartPdfOptions,
				theme: "metro",
				title: {
					text: self.getJourneyTitle("CONSUMO MEDIO (L/100KM)"),
					font: "bold 20px montserrat-bold"
				},
				legend: {
					position: "bottom",
					item: {
						visual: function(e) {
							var rect = new kendo.geometry.Rect([0, 0], [800, 200]);
							var layout = new kendo.drawing.Layout(rect, {
								spacing: 5,
								alignItems: "center"
							});

							var color = e.series.color; //e.options.markers.background;
							var labelColor = e.options.labels.color;

							var marker = new kendo.drawing.Path({
								fill: {
									color: color
								},
								stroke: {
									color: color
								}
							})
								.moveTo(0, 0)
								.lineTo(0, 10)
								.lineTo(30, 10)
								.lineTo(30, 0)
								.close();

							var label = new kendo.drawing.Text(e.series.name.toUpperCase(), [0, 0], {
								fill: {
									color: labelColor
								},
								font: "12px 'Montserrat Light', montserrat-light"
							});

							var rectGeom = new kendo.geometry.Rect([0, 0], [30, 10]);
							var rectangle = new kendo.drawing.Rect(rectGeom, {
								fill: { color: "none" },
								stroke: { color: "none" }
							});

							layout.append(marker, label);
							layout.reflow();

							return layout;
						}
					}
				},
				seriesDefault: {
					type: "column",
					labels: {
						visible: true
					}
				},
				dataSource: {
					data: self.journeyChartAvgFuelConsumptionData
				},
				series: self.journeyChartAvgFuelConsumptionExport,
				valueAxis: self.journeyChartLtHKmValueAxisModal,
				categoryAxis: {
					categories: self.journeyChartAvgFuelConsumptionCategoryAxis.categories,
					majorGridLines: {
						visible: false
					},
					line: {
						visible: false
					},
					labels: {
						font: "13px montserrat-light"
					}
				}
			};

			//options = $.extend(true, options, exportOptions);
			$(container)
				.find(`#${chartConatinerName}`)
				.kendoChart(options);
		},

		createChart4(container, chartConatinerName) {
			var self = this;

			var options = {
				chartArea: {
					height: 700
				},
				pdf: self.journeyChartPdfOptions,
				theme: "metro",
				title: {
					text: self.getJourneyTitle("CONSUMO MEDIO (KM/LT)"),
					font: "bold 20px montserrat-bold"
				},
				legend: {
					position: "bottom",
					item: {
						visual: function(e) {
							var rect = new kendo.geometry.Rect([0, 0], [800, 200]);
							var layout = new kendo.drawing.Layout(rect, {
								spacing: 5,
								alignItems: "center"
							});

							var color = e.series.color; //e.options.markers.background;
							var labelColor = e.options.labels.color;

							var marker = new kendo.drawing.Path({
								fill: {
									color: color
								},
								stroke: {
									color: color
								}
							})
								.moveTo(0, 0)
								.lineTo(0, 10)
								.lineTo(30, 10)
								.lineTo(30, 0)
								.close();

							var label = new kendo.drawing.Text(e.series.name.toUpperCase(), [0, 0], {
								fill: {
									color: labelColor
								},
								font: "12px 'Montserrat Light', montserrat-light"
							});

							var rectGeom = new kendo.geometry.Rect([0, 0], [30, 10]);
							var rectangle = new kendo.drawing.Rect(rectGeom, {
								fill: { color: "none" },
								stroke: { color: "none" }
							});

							layout.append(marker, label);
							layout.reflow();

							return layout;
						}
					}
				},
				seriesDefault: {
					type: "column",
					labels: {
						visible: true
					}
				},
				dataSource: {
					data: self.journeyChartAvgFuelConsumptionBrandData
				},
				series: self.journeyChartAvgFuelConsumptionBrandExport,
				valueAxis: self.journeyChartKmLtValueAxisModal,
				categoryAxis: {
					categories: self.journeyChartAvgFuelConsumptionBrandCategoryAxis.categories,
					majorGridLines: {
						visible: false
					},
					line: {
						visible: false
					},
					labels: {
						font: "13px montserrat-light"
					}
				}
			};

			//options = $.extend(true, options, exportOptions);
			$(container)
				.find(`#${chartConatinerName}`)
				.kendoChart(options);
		},

		createChart5(container, chartConatinerName) {
			var self = this;

			var options = {
				chartArea: {
					height: 700
				},
				pdf: self.journeyChartPdfOptions,
				theme: "metro",
				title: {
					text: ""
					// text: self.getJourneyTitle('EMISSIONI CO2'),
					// font: "bold 20px montserrat-bold"
				},
				legend: {
					position: "bottom",
					item: {
						visual: function(e) {
							var rect = new kendo.geometry.Rect([0, 0], [800, 200]);
							var layout = new kendo.drawing.Layout(rect, {
								spacing: 5,
								alignItems: "center"
							});

							var color = e.series.color; //e.options.markers.background;
							var labelColor = e.options.labels.color;

							var marker = new kendo.drawing.Path({
								fill: {
									color: color
								},
								stroke: {
									color: color
								}
							})
								.moveTo(0, 0)
								.lineTo(0, 10)
								.lineTo(30, 10)
								.lineTo(30, 0)
								.close();

							var label = new kendo.drawing.Text(e.series.name.toUpperCase(), [0, 0], {
								fill: {
									color: labelColor
								},
								font: "12px 'Montserrat Light', montserrat-light"
							});

							var rectGeom = new kendo.geometry.Rect([0, 0], [30, 10]);
							var rectangle = new kendo.drawing.Rect(rectGeom, {
								fill: { color: "none" },
								stroke: { color: "none" }
							});

							layout.append(marker, label);
							layout.reflow();

							return layout;
						}
					}
				},
				seriesDefault: {
					type: "column",
					labels: {
						visible: true
					}
				},
				dataSource: {
					data: self.journeyChartCoEmittedData
				},
				series: self.journeyChartCoEmittedExport,
				valueAxis: self.journeyChartKgValueAxisModal,
				categoryAxis: {
					categories: self.journeyChartCoEmittedCategoryAxis.categories,
					majorGridLines: {
						visible: false
					},
					line: {
						visible: false
					},
					labels: {
						visible: false,
						font: "13px montserrat-light"
					},
					title: {
						text: "emissioni CO 2",
						visual: function(e) {
							var labelColor = e.options.color;
							var layout = new kendo.drawing.Layout(e.rect, {
								orientation: "horizontal",
								alignItems: "end",
								alignContent: "end",
								justifyContent: "center"
							});

							var labelCenter = new kendo.drawing.Text(" CO", [0, 0], {
								fill: {
									color: labelColor
								},
								font: "12px 'Montserrat Light', montserrat-light"
							});

							var labelSuf = new kendo.drawing.Text("2", [0, 0], {
								fill: {
									color: labelColor
								},
								font: "7px 'Montserrat Light', montserrat-light "
							});

							var labelPre = new kendo.drawing.Text(" EMISSIONI", [0, 0], {
								fill: {
									color: labelColor
								},
								font: "12px 'Montserrat Light', montserrat-light"
							});
							var labelEnd = new kendo.drawing.Text(" (KG)", [0, 0], {
								fill: {
									color: labelColor
								},
								font: "12px 'Montserrat Light', montserrat-light"
							});
							layout.append(labelPre, labelCenter, labelSuf, labelEnd);
							layout.reflow();
							return layout;
						}
					}
				}
			};

			//options = $.extend(true, options, exportOptions);
			var titleChart = self.getJourneyTitle("EMISSIONI CO<sub>2</sub>");
			$(container)
				.find(`#chart5-title`)
				.html(titleChart);
			$(container)
				.find(`#${chartConatinerName}`)
				.kendoChart(options);
		},

		//#endregion export chart

		//#region export xls
		exportAsXlsx(type) {
			var self = this;

			var data = this.getRequestData();
			if (type == "csv") data["format"] = "csv";
			ApiService.exportChartXlsx("journey", data).then(res => {
				let blob = self.$options.filters.b64toBlob(res.data.fileContents);
				let link = document.createElement("a");
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", res.data.fileDownloadName || `percorrenza.${type}`);
				link.style = "visibility:hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			});
		}
		//#endregion export xls
	},
	computed: {
		...mapGetters(["settings"])
	}
};
